import clsx from 'clsx';
import { FC, memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import NotificationCard from 'src/components/common/notification';
import { useIsMiddleSchoolView } from 'src/hooks/use-is-middle-school-view';
import { AssignmentsViewOptions } from 'src/interfaces/assignment.types';

import './no-assignments-card.scss';

const animalGifs = [
  'https://learning.amplify.com/m/5853c33c6bca87bd/original/StudentHome_Cat_empty-screen_K_5.gif',
  'https://learning.amplify.com/m/6942bb0826905151/original/StudentHome_Fox_empty-screen_K_5.gif',
  'https://learning.amplify.com/m/2815e61cc260bbc9/original/StudentHome_Crane_empty-screen_K_5.gif',
];

const getRandomImageSrc = () => {
  return animalGifs[Math.floor(Math.random() * animalGifs.length)];
};

type Props = {
  k5Section?: AssignmentsViewOptions.PAST_WORK | AssignmentsViewOptions.TODO;
};

const NoAssignmentsCard: FC = ({ k5Section }: Props) => {
  const { t } = useTranslation();

  const isMiddleSchoolView = useIsMiddleSchoolView();
  const isTodoSectionActive = k5Section === AssignmentsViewOptions.TODO;

  const title = isTodoSectionActive
    ? t('You do not have any assignments.')
    : t('There is nothing here yet!');

  const imageSrc = useMemo(() => getRandomImageSrc(), []);

  return (
    <div
      className={clsx('no-assignments', {
        'no-assignments--middle-school': isMiddleSchoolView,
      })}
      role="alert"
    >
      <NotificationCard title={title} src={imageSrc} />
    </div>
  );
};

// used memo to prevent images changing during one assignment list
const MemoizedNoAssignmentsCard = memo<Props>(NoAssignmentsCard);

export default MemoizedNoAssignmentsCard;
